/* eslint-disable no-useless-computed-key */
import { oldApiInstance } from 'functions/request';

export const fetchShopDataApi = search =>
  oldApiInstance.get('/shop/coupons_finder', {
    params: {
      search,
      per_page: 40,
      page: 1,
      on_sale_items_per_page: 40,
      on_sale_items_page: 1,
    },
  });
